export default __webpack_public_path__ + "static/media/wwg-store-icon.1e8df9bb.svg";